import { useEffect, useState } from 'react';

import { getCurrentUserInfo } from '../../../utils/auth';
import getAddressFromId from '../../../utils/getAddressFromId';

import InformationPanel from './InformationPanel';

const AccountInformation = () => {
  const [currentUserInfo, setCurrentUserInfo] = useState(undefined);

  useEffect(() => {
    getCurrentUserInfo().then((res) => setCurrentUserInfo(res));
  }, []);

  return (
    <InformationPanel title="Account information" isLoading={!currentUserInfo}>
      <li>Name: {currentUserInfo?.attributes?.name}</li>
      <li>Address: {currentUserInfo?.attributes?.address && getAddressFromId(currentUserInfo?.attributes?.address)}</li>
      <li>Email address: {currentUserInfo?.attributes?.email}</li>
      <li>Password: ••••••••</li>
    </InformationPanel>
  );
};

export default AccountInformation;
